export default __webpack_public_path__ + "static/infeedo-7514a4bef6f47f9d6e881505cb8afa55.svg";